import CheckMark from '@allesauto/design/graphics/checked.svg';
import { getSlug } from '@allesauto/utils/funcs';
import { isAuregoShop } from '@allesauto/utils/funcs.ts';
import clsx from 'clsx';
import React, { FC, useEffect, useState } from 'react';

import { useWhiteLabel } from '../whiteLabel';

export interface ColorIconProps {
  onClick?: (name: string, added: boolean) => any;
  isDefaultActive?: boolean;
  hex: string;
  displayName?: string;
  name: string;
  highlighted?: boolean;
}

const ColorIcon: FC<ColorIconProps> = (props: ColorIconProps) => {
  const { onClick, isDefaultActive = false, hex, displayName, name } = props;
  const [active, setActive] = useState(isDefaultActive || false);
  const trackingIdentifier = `aa-filter--colour-${getSlug(name)}`;
  const whiteLabel = useWhiteLabel();

  useEffect(() => {
    setActive(isDefaultActive);
  }, [isDefaultActive]);

  const className = {
    squareContainer: clsx(
      '!border-[3px] aspect-square aurego-color-border flex flex-col justify-center max-h-[110px] max-w-[110px] rounded-default monochrome:group-hover!:border-grey40 group-hover:border-green60 ',
      active && 'border-green60 monochrome:border-grey40',
      !active && 'border-white'
    ),
    squareDiv: clsx(
      'aspect-square border-1px cursor-pointer flex items-center justify-center rounded-[2px] shadow-border sm:h-[87.33px] group-hover:shadow-green60',
      'monochrome:group-hover:shadow-grey40',
      active &&
        ` ${
          isAuregoShop(whiteLabel)
            ? 'bg-transparent'
            : 'shadow-green60 monochrome:shadow-grey40'
        }`,
      !active && 'shadow-white'
    ),
    checkMark: clsx('h-1/6 place-content-center w-1/6'),
    container: clsx(
      'grid grid-cols-1 group justify-items-center max-h-[150px] max-w-[103px] mb-30px place-content-center'
    ),
    displayText: clsx(
      'font-normal leading-5 mt-5px text-center text-p2 group-hover:font-weight-bold group-hover:text-green60',
      'monochrome:group-hover:text-grey40',
      active && 'font-weight-bold text-green60 monochrome:text-white',
      !active && 'font-weight-normal text-white monochrome:text-white'
    ),
  };
  const { squareDiv, checkMark, container, displayText, squareContainer } =
    className;

  const onColorClick = () => {
    setActive(!active);
    onClick && onClick(name, !active);
  };
  return (
    <div className={container}>
      <div className={squareContainer}>
        <div
          className={squareDiv}
          style={{
            backgroundColor: hex,
            borderColor: hex,
          }}
          data-tracking-id={trackingIdentifier}
          onClick={onColorClick}
        >
          <CheckMark
            className={checkMark}
            style={
              !active
                ? {
                    color: isAuregoShop(whiteLabel)
                      ? 'black'
                      : hex || 'transparent',
                  }
                : { color: isAuregoShop(whiteLabel) ? 'black' : 'white' }
            }
          />
        </div>
      </div>
      <p className={displayText}>{displayName}</p>
    </div>
  );
};

export default ColorIcon;
